import { render, staticRenderFns } from "./CreateWork.vue?vue&type=template&id=2ff98c8e&scoped=true&"
import script from "./CreateWork.vue?vue&type=script&lang=js&"
export * from "./CreateWork.vue?vue&type=script&lang=js&"
import style0 from "./CreateWork.vue?vue&type=style&index=0&id=2ff98c8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff98c8e",
  null
  
)

export default component.exports